export { SimSidenavComponent } from './sim-sidenav.component';
